import { render, staticRenderFns } from "./TaskCategoryEdit.vue?vue&type=template&id=86ef8052&"
import script from "./TaskCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./TaskCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports